import {medal_getMedalAwardsOfOrganization_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {branch, compose, fromRenderProps} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {DateNameSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {NullAsDefault} from 'views/Shared'
import WorkspaceContext from '../WorkspaceContext';
import {MedalAwardFilter} from './MedalFilter'
import renderMedalAward from './renderMedalAward'
import {useMedalManager} from './userMedalManager'
import {useRouteSearchParam} from "../../../envs/_current/history";

const WorkspaceMedalAwardsHistory = ({
                                         owner_id,
                                         owner_type,
                                         Wrapper = 'div',
                                         filter_actions = {
                                             sortBy: 'sort-by',
                                             keyword: 'keyword',
                                             to_date: 'to-date',
                                             from_date: 'from-date',
                                         },
                                     }) => {
    const t = useTranslate()

    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const filter_to_date = useRouteSearchParam(filter_actions.to_date)

    const filter_from_date = useRouteSearchParam(filter_actions.from_date)

    const {
        refreshKey,
        modal = null,
        handleAction = NullAsDefault,
    } = useMedalManager({
        owner_id,
        owner_type,
    })

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                from_date: filter_from_date,
                to_date: filter_to_date,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: NullAsDefault,
            apiInfo: medal_getMedalAwardsOfOrganization_Api,
            query: bindQueryParams([{id: owner_id}, {prop: owner_type}]),
            renderItem: renderMedalAward({
                // renderContextMenu,
            }),
            renderWrap: (child) => (
                <div className="mt-2 flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            )
        },
        sortHeader: t('history certification rewards'),
        SortByWidget: DateNameSortBy,
        query_params: filter_actions,
        AdvancedFilter: MedalAwardFilter,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })

    return (
        <Wrapper className="flex flex-col space-y-3">
            <div className="flex flex-col flex-1">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                    {t('history certification rewards')}
                </h2>
                <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
            </div>
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </Wrapper>
    )
}

export default compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        owner_id: getId(organization),
        owner_type: getType(organization),
    })),
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], (e) => !e),
        () => () => <ContentNotFound/>
    )
)(WorkspaceMedalAwardsHistory)
